module.exports = require('./dist/next-server/lib/amp')
